import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_booking/flightsmanyquery/results')({
  beforeLoad: () => {
    // Legacy path. The free-text `?q=` search it used to carry no longer exists;
    // land on the results page, which shows its own empty state.
    throw redirect({ replace: true, to: '/vols-multi/resultats' })
  },
})
